var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmoothUx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_13878_11617)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7834 30.4348C41.9264 30.4348 42.8529 31.3614 42.8529 32.5044V37.7131C42.8529 38.2654 43.3007 38.7131 43.8529 38.7131H49.0616C50.2046 38.7131 51.1312 39.6397 51.1312 40.7826C51.1312 41.9256 50.2046 42.8522 49.0616 42.8522H43.8529C43.3007 42.8522 42.8529 43.2999 42.8529 43.8522V49.0609C42.8529 50.2039 41.9264 51.1305 40.7834 51.1305C39.6404 51.1305 38.7138 50.2039 38.7138 49.0609V43.8522C38.7138 43.2999 38.2661 42.8522 37.7138 42.8522H32.5051C31.3621 42.8522 30.4355 41.9256 30.4355 40.7826C30.4355 39.6397 31.3621 38.7131 32.5051 38.7131H37.7138C38.2661 38.7131 38.7138 38.2654 38.7138 37.7131V32.5044C38.7138 31.3614 39.6404 30.4348 40.7834 30.4348Z",
    fill: "#EDF0F5",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7834 30.4348C41.9264 30.4348 42.8529 31.3614 42.8529 32.5044V37.7131C42.8529 38.2654 43.3007 38.7131 43.8529 38.7131H49.0616C50.2046 38.7131 51.1312 39.6397 51.1312 40.7826C51.1312 41.9256 50.2046 42.8522 49.0616 42.8522H43.8529C43.3007 42.8522 42.8529 43.2999 42.8529 43.8522V49.0609C42.8529 50.2039 41.9264 51.1305 40.7834 51.1305C39.6404 51.1305 38.7138 50.2039 38.7138 49.0609V43.8522C38.7138 43.2999 38.2661 42.8522 37.7138 42.8522H32.5051C31.3621 42.8522 30.4355 41.9256 30.4355 40.7826C30.4355 39.6397 31.3621 38.7131 32.5051 38.7131H37.7138C38.2661 38.7131 38.7138 38.2654 38.7138 37.7131V32.5044C38.7138 31.3614 39.6404 30.4348 40.7834 30.4348Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3501 30.4348C19.3923 30.4348 19.4346 30.436 19.4768 30.4385L19.961 30.4675C19.9999 30.4698 20.0387 30.4732 20.0774 30.4778C21.5896 30.6544 22.9841 31.3807 23.9958 32.5186C25.0076 33.6564 25.5659 35.1265 25.5648 36.6492V44.9094C25.5648 46.5549 24.9116 48.1332 23.7489 49.2974C22.5863 50.4613 21.0094 51.1161 19.3646 51.118L11.088 51.1305C11.0461 51.1305 11.0042 51.1293 10.9623 51.1268L10.474 51.0979C10.4348 51.0955 10.3956 51.0921 10.3565 51.0875C8.84544 50.911 7.45177 50.1856 6.44018 49.049C5.42859 47.9125 4.86952 46.444 4.86914 44.9223L4.86914 36.6559C4.86914 35.0093 5.52314 33.4301 6.68726 32.2657C7.85098 31.1018 9.42919 30.4477 11.0749 30.4472C11.0743 30.4472 11.0755 30.4472 11.0749 30.4472M19.2929 34.574L11.0797 34.5864C10.5309 34.5864 10.0015 34.8044 9.61348 35.1925C9.22544 35.5806 9.00744 36.107 9.00744 36.6559V44.9213C9.00744 44.9211 9.00744 44.9214 9.00744 44.9213C9.0077 45.4283 9.19404 45.9181 9.53112 46.2968C9.85747 46.6635 10.3031 46.9018 10.7881 46.9701L11.1446 46.9912L19.3584 46.9789C19.9068 46.9784 20.4336 46.7601 20.8212 46.372C21.2088 45.984 21.4265 45.4579 21.4265 44.9094V36.6477C21.4269 36.1401 21.2407 35.6485 20.9035 35.2692C20.577 34.902 20.1309 34.6634 19.6454 34.5951L19.2929 34.574Z",
    fill: "url(#paint0_linear_13878_11617)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3501 4.86963C19.3923 4.86957 19.4346 4.8708 19.4768 4.87332L19.961 4.9023C19.9999 4.90462 20.0387 4.90805 20.0774 4.91257C21.5896 5.08921 22.9841 5.81551 23.9958 6.95337C25.0076 8.09122 25.5659 9.56128 25.5648 11.084V19.3442C25.5648 20.9897 24.9116 22.568 23.7489 23.7322C22.5863 24.8961 21.0094 25.5509 19.3646 25.5529L11.088 25.5653C11.0461 25.5653 11.0042 25.5641 10.9623 25.5616L10.474 25.5327C10.4348 25.5303 10.3956 25.5269 10.3565 25.5223C8.84544 25.3458 7.45177 24.6204 6.44018 23.4839C5.42859 22.3473 4.86952 20.8788 4.86914 19.3571L4.86914 11.0907C4.86914 9.4441 5.52314 7.86489 6.68726 6.70053C7.85098 5.53658 9.42919 4.8825 11.0749 4.88205C11.0743 4.88205 11.0755 4.88205 11.0749 4.88205M19.2929 9.00885L11.0797 9.02118C10.5309 9.02118 10.0015 9.23922 9.61348 9.62734C9.22544 10.0155 9.00744 10.5419 9.00744 11.0907V19.3561C9.00744 19.3559 9.00744 19.3562 9.00744 19.3561C9.0077 19.8631 9.19404 20.3529 9.53112 20.7317C9.85747 21.0983 10.3031 21.3366 10.7881 21.4049L11.1446 21.4261L19.3584 21.4137C19.9068 21.4132 20.4336 21.1949 20.8212 20.8068C21.2088 20.4188 21.4265 19.8927 21.4265 19.3442V11.0825C21.4269 10.5749 21.2407 10.0833 20.9035 9.70403C20.577 9.33683 20.1309 9.09821 19.6454 9.02995L19.2929 9.00885Z",
    fill: "url(#paint1_linear_13878_11617)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9165 4.86963C44.9588 4.86957 45.001 4.8708 45.0432 4.87332L45.5274 4.9023C45.5663 4.90462 45.6051 4.90805 45.6438 4.91257C47.156 5.08921 48.5505 5.81551 49.5622 6.95337C50.574 8.09122 51.1323 9.56128 51.1312 11.084V19.3442C51.1312 20.9897 50.4781 22.568 49.3153 23.7322C48.1527 24.8961 46.5759 25.5509 44.931 25.5529L36.6544 25.5653C36.6125 25.5653 36.5706 25.5641 36.5287 25.5616L36.0404 25.5327C36.0012 25.5303 35.962 25.5269 35.9229 25.5223C34.4118 25.3458 33.0182 24.6204 32.0066 23.4839C30.995 22.3473 30.4359 20.8788 30.4355 19.3571L30.4355 11.0907C30.4355 9.4441 31.0895 7.86489 32.2537 6.70053C33.4174 5.53658 34.9956 4.8825 36.6413 4.88205",
    fill: "url(#paint2_linear_13878_11617)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_13878_11617",
    x: 18.4832,
    y: 18.4824,
    width: 44.6001,
    height: 44.6003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.47619
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_13878_11617"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_13878_11617",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13878_11617",
    x1: 4.2224,
    y1: 51.5254,
    x2: 50.0266,
    y2: 15.6096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13447,
    stopColor: "#38B2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677447,
    stopColor: "#F7E74E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13878_11617",
    x1: 4.2224,
    y1: 25.9602,
    x2: 50.0266,
    y2: -9.95558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13447,
    stopColor: "#38B2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677447,
    stopColor: "#F7E74E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13878_11617",
    x1: 29.7888,
    y1: 25.9602,
    x2: 75.593,
    y2: -9.95558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13447,
    stopColor: "#38B2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677447,
    stopColor: "#F7E74E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoothUx);
export default __webpack_public_path__ + "static/media/smooth-ux.f680ec57445037a78336e2c6406c77bb.svg";
export { ForwardRef as ReactComponent };